import { IntroLayoutBody, IntroLayoutWrapper } from './introLayoutStyled';

const IntroLayout = ({ children }: any) => {
  return (
    <>
      <IntroLayoutWrapper>
        <div>
          <h1>Welcome to Travelution!</h1>
          <h2>
            Get ready for upgraded experience <br /> with your Travelution
            Backoffice!
          </h2>
        </div>
        <IntroLayoutBody>{children}</IntroLayoutBody>
      </IntroLayoutWrapper>
    </>
  );
};

export default IntroLayout;
